export class QuoteOptInDiscountOutput {
    constructor(item) {
        if (item) {
            this.id = item.id;
            this.name = item.name;
            this.supportingDocumentsRequired = item.supportingDocumentsRequired;
            this.supportingDocumentsPromptText = item.supportingDocumentsPromptText;
        }
    }
}
